import React from "react";

import bbq1Src from "../../images/bbq-01.jpg";
import bbq2Src from "../../images/bbq-02.jpg";
import bbq3Src from "../../images/bbq-03.jpg";

import bbqFull1Src from "../../images/bbq-full-01.jpg";
import bbqFull2Src from "../../images/bbq-full-02.jpg";
import bbqFull3Src from "../../images/bbq-full-03.jpg";

import contentBgSrc from "../../images/not-available-bbq.png";

export const slides = [
  {
    id: 1,
    name: "Apple Pie Pulled Pork",
    label: (
      <span>
        Apple Pie
        <br />
        Pulled Pork
      </span>
    ),
    imageSrc: bbq1Src,
    imageFullSrc: bbqFull1Src,
    contentBgSrc,
    ingredients: [
      {
        id: 1,
        text: "2 lb Pork Loin or Butt Roast",
      },
      {
        id: 2,
        text: "½ cup Ketchup",
      },
      {
        id: 3,
        text: "½ cup Barbecue Sauce",
      },
      {
        id: 4,
        text: "¼ cup Apple Cider Vinegar",
      },
      {
        id: 5,
        text: "¼ cup Ole Smoky ® Apple Pie Moonshine",
      },
      {
        id: 6,
        text: "¼ cup Brown Sugar, lightly packed",
      },
      {
        id: 7,
        text: "1 tsp Dijon Mustard",
      },
      {
        id: 8,
        text: "1 tbsp Worcestershire Sauce",
      },
      {
        id: 9,
        text: "2 tbsp Minced Onion",
      },
      {
        id: 10,
        text: "1 clove Garlic, Minced",
      },
      {
        id: 11,
        text: "½ tsp Smoked Paprika",
      },
      {
        id: 12,
        text: "½ tsp Cayenne or Hot Sauce",
      },
      {
        id: 13,
        text: "Freshly ground Salt and Pepper to taste",
      },
    ],
  },
  {
    id: 2,
    name: "Peach Infused Baby-Back Ribs",
    label: (
      <span>
        Peach Infused
        <br />
        Baby-Back Ribs
      </span>
    ),
    imageSrc: bbq2Src,
    imageFullSrc: bbqFull2Src,
    contentBgSrc,
    ingredients: [
      {
        id: 1,
        text: "½ tsp Garlic Powder",
      },
      {
        id: 2,
        text: "1 ¼ cups Ketchup",
      },
      {
        id: 3,
        text: "¼ cup Molasses",
      },
      {
        id: 4,
        text: "2 ½ tsp Ground Mustard",
      },
      {
        id: 5,
        text: "1 tbsp Worcestershire Sauce",
      },
      {
        id: 6,
        text: "1 cup Dark Brown Sugar",
      },
      {
        id: 7,
        text: "¼ tsp Cayenne Pepper",
      },
      {
        id: 8,
        text: "2 tsp Smoked Paprika",
      },
      {
        id: 9,
        text: "1 tsp Black Pepper",
      },
      {
        id: 10,
        text: "1 ½ Salt",
      },
      {
        id: 11,
        text: "¼ cup Apple Cider Vinegar",
      },
      {
        id: 12,
        text: "½ cup Ole Smoky® Peach Whiskey",
      },
    ],
  },
  {
    id: 3,
    name: "Blackberry Smoked Gamebird",
    label: (
      <span>
        Blackberry
        <br />
        Smoked Gamebird
      </span>
    ),
    imageSrc: bbq3Src,
    imageFullSrc: bbqFull3Src,
    contentBgSrc,
    ingredients: [
      {
        id: 1,
        text:
          "4 large chicken legs and thighs, skinless or skin on, your call.",
      },
      {
        id: 2,
        text: "Salt & Pepper",
      },
      {
        id: 3,
        text: "Rosemary",
      },
      {
        id: 4,
        text: "2 cups Ole Smoky ® Blackberry Moonshine",
      },
      {
        id: 5,
        text: "Hickory Wood",
      },
    ],
  },
];
